import { useEffect, useState } from "react";

const useWindowLocationHref = () => {
	const [windowLocationHref, setWindowLocationHref] = useState("");

	useEffect(() => {
		setWindowLocationHref(window.location.href);
	}, []);

	return { windowLocationHref };
};

export default useWindowLocationHref;
